import { useQuery, type UseQueryOptions } from '@tanstack/react-query';
import {
	type LWApiPublicUsertaskListParamsRawI,
	type LWApiPublicUsertaskListResultRawI,
} from '@liquidweb-dev/club-sauce/public/usertask/index.raw';
import type { ApiErrorI } from '@liquidweb-dev/club-sauce/types/apiError';
import api from 'modules/queries/api';

export const USERTASK_LIST_QUERY_KEY = '/usertask/list';

const useUsertaskList = (
	params: LWApiPublicUsertaskListParamsRawI,
	options?: UseQueryOptions<LWApiPublicUsertaskListResultRawI, ApiErrorI>,
) =>
	useQuery({
		queryKey: [USERTASK_LIST_QUERY_KEY, params],
		queryFn: () => api.usertask.apiRaw.list(params),
		...options,
	});

export default useUsertaskList;
